import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface PixabayImage {
  id: number;
  previewURL: string;
  webformatURL: string;
  largeImageURL: string;
  imageWidth: number;
  imageHeight: number;
  tags: string;
  user: string;
}

export interface PixabayResponse {
  total: number;
  totalHits: number;
  hits: PixabayImage[];
}

@Injectable({
  providedIn: 'root'
})
export class PixabayService {
  private readonly apiKey = '3670558-eac11c108fd0a6c7f5ebaaf75';
  private readonly baseUrl = 'https://pixabay.com/api/';

  readonly categories = [
    { name: 'Studio', query: 'studio background gradient smooth' },
    { name: 'Textures', query: 'texture abstract pattern seamless' },
    { name: 'Marble', query: 'marble texture stone surface' },
    { name: 'Wood', query: 'wood texture grain surface' },
    { name: 'Fabric', query: 'fabric texture linen canvas' },
    { name: 'Paper', query: 'paper texture vintage parchment' },
    { name: 'Concrete', query: 'concrete wall texture gray' },
    { name: 'Nature', query: 'nature blur bokeh soft' },
    { name: 'Gradient', query: 'gradient color smooth abstract' },
    { name: 'Minimal', query: 'minimal white clean simple' }
  ];

  constructor(private http: HttpClient) {}

  searchImages(query: string, page: number = 1, perPage: number = 20): Observable<PixabayResponse> {
    const params = {
      key: this.apiKey,
      q: query,
      image_type: 'photo',
      orientation: 'horizontal',
      safesearch: 'true',
      per_page: perPage.toString(),
      page: page.toString(),
      min_width: '800',
      min_height: '800'
    };

    const url = `${this.baseUrl}?${new URLSearchParams(params).toString()}`;
    return this.http.get<PixabayResponse>(url);
  }

  searchByCategory(categoryName: string, page: number = 1): Observable<PixabayResponse> {
    const category = this.categories.find(c => c.name === categoryName);
    const query = category ? category.query : categoryName;
    return this.searchImages(query, page);
  }

  loadImage(url: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = url;
    });
  }

  getAttribution(image: PixabayImage): string {
    return `Image by ${image.user} from Pixabay`;
  }
}
